/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import TextureDataHandler from "App/utils/textures/texture_data_handler";
import {EDataTypeType} from "App/geometry/material/texture";
import ImageDataLoadersFactory from "App/utils/textures/image_data_loaders_factory";
import ImageDataLoader from "App/utils/textures/image_data_loader";

export default
class CRNImageDataLoader extends ImageDataLoader {

    public static TypeName: string = EDataTypeType.crunchImageTexture;

    constructor(aTextureDataHandler: TextureDataHandler, aDiffuseTextureProperties: any, aLevel: number) {
        super(aTextureDataHandler, aDiffuseTextureProperties, aLevel);
    }

    public static create(aTextureDataHandler: TextureDataHandler, aDiffuseTextureProperties: any, aLevel: number): CRNImageDataLoader {
        return new CRNImageDataLoader(aTextureDataHandler, aDiffuseTextureProperties, aLevel);
    }

    public prepareData() {
        if (this._loadIterator >= this.tiles.length) {
            return;
        }
        let tile = this.tiles[this._loadIterator];
        this._textureDataHandler.decodeCrunchTexture(this._loadIterator, tile.compressedUint8Data);

        this._loadIterator++;
    };

    public crunchTextureDecoded(aMessage: any) {
        let tile = this.tiles[aMessage.tileIndex];

        // we need only init the width and height here
        tile.width = aMessage.ddsData.width;
        tile.height = aMessage.ddsData.height;
        tile.data = aMessage.ddsData;

        // here we test if we specify the texture using only the url wihtout knowing the size of it
        // it this case we re-init the properties based on th reloaded dom image object
        if (!this._diffuseTextureProperties.tiled &&
            this._diffuseTextureProperties.width === 0 &&
            this._diffuseTextureProperties.height === 0) {
            tile.width = tile.data.width;
            tile.height = tile.data.height;
            this._diffuseTextureProperties.width = tile.width;
            this._diffuseTextureProperties.height = tile.height;
        }

        tile.ready = true;

        // force the alpha according to the format
        this._diffuseTextureProperties.alpha = tile.data.hasAlpha;
    }
}

ImageDataLoadersFactory.register(CRNImageDataLoader);